<template>
  <div class="unauthorized">
    <h1>Acesso NEGADO!</h1>
    <p>Você não tem permissão para ver esta página, ou, seu login expirou!</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();

onMounted(() => {
  // When the unauthorized page is loaded, clear the token and user data.
  userStore.logout();
});
</script>

<style scoped>
.unauthorized {
  text-align: center;
  margin-top: 20vh;
}
</style>
